import type { SearchCategory } from '../features/home-preview/model'

export const OPEN_HUB_SEARCH = 'open-hub-search'
export type HubSearchOptions = { query?: string; category?: SearchCategory }

/** Every search entry point opens the single modal hosted by the header. */
export function openHubSearch(options: HubSearchOptions = {}) {
  window.dispatchEvent(new CustomEvent<HubSearchOptions>(OPEN_HUB_SEARCH, { detail: options }))
}
